module.exports = __webpack_public_path__ + "static/testimonial-1-2c781b328ce5ae150e933f84a0088e9f.png";